module.exports = __webpack_public_path__ + "img/aiIntroduce-image.ae062e96.png";